/**
 * A function that does essentially nothing, which could be used as a placeholder
 * or default for other functions.
 *
 * **Note** "noop" is short for "no operation".
 */
export function noop(): void {
  return void 0
}
